<!--Formulario administrador líder-->
<div class="wrapper__form container my-5 border__form">
  <app-form
    *ngIf="esAdminLider"
    [title]="'crear-administrador.titulo-lider' | translate"
    [fields]="camposAdminLider"
    [withSubmitButton]="true"
    (changedControl)="validarCorreo($event)"
    (submitAction)="onSubmitAdminLider($event)">
  </app-form>
  <!--Formulario administrador funcional-->
  <app-form
    *ngIf="esAdminFuncional"
    [title]="'crear-administrador.titulo-funcional' | translate"
    [fields]="camposAdminFuncional"
    [withSubmitButton]="true"
    (changedControl)="validarCorreo($event)"
    (submitAction)="onSubmitAdminFuncional($event)">
  </app-form>
</div>
